import allDashifyComponents from './allDashifyComponents';
import allDashifyVisualizations from './allDashifyVisualizations';
import dashifyDocumentation from './documentation.json';

import other from './other';

export default [...allDashifyComponents, ...allDashifyVisualizations, ...other, dashifyDocumentation];
